import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActivityTypesDirective } from '@app/pcs/shared/directives/activity-types.directive';
import { CorridorSelectDirective } from '@app/pcs/shared/directives/corridor-select.directive';
import { HideIfReadonlyUserDirective } from '@app/pcs/shared/directives/hide-if-readonly-user.directive';
import { MandatoryDirective } from '@app/pcs/shared/directives/mandatory.directive';
import { PapTypeDirective } from '@app/pcs/shared/directives/pap-type.directive';
import { ParameterSetCodeDirective } from '@app/pcs/shared/directives/parameter-set-code.directive';
import { ShowIfRoleDirective } from '@app/pcs/shared/directives/show-if-role.directive';
import { ShowIfUserDirective } from '@app/pcs/shared/directives/show-if-user.directive';
import { WarningDirective } from '@app/pcs/shared/directives/warning-directive';

import { AgencySelectDirective } from './agency-select.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ShowIfUserDirective,
    PapTypeDirective,
    ParameterSetCodeDirective,
    MandatoryDirective,
    ShowIfRoleDirective,
    HideIfReadonlyUserDirective,
    ActivityTypesDirective,
    AgencySelectDirective,
    WarningDirective,
    CorridorSelectDirective
  ],
  providers: [],
  exports: [
    ShowIfUserDirective,
    PapTypeDirective,
    ParameterSetCodeDirective,
    MandatoryDirective,
    ShowIfRoleDirective,
    HideIfReadonlyUserDirective,
    ActivityTypesDirective,
    AgencySelectDirective,
    WarningDirective,
    CorridorSelectDirective
  ]
})
export class PcsDirectivesModule {
}
